import { render } from "./FollowerStats.vue?vue&type=template&id=28eb1449&scoped=true"
import script from "./FollowerStats.vue?vue&type=script&lang=js"
export * from "./FollowerStats.vue?vue&type=script&lang=js"

import "./FollowerStats.vue?vue&type=style&index=0&id=28eb1449&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28eb1449"]])

export default __exports__